$( function() {
	/*
	$('ul.slider').phunkslider({
		interval : 8000
	});*/

	$('ul.slider').find('li').first().addClass('active');
});